module.exports = __webpack_public_path__ + "img/yanglao.fa937491.png";